export interface UserAdminTab {
  label: string;
  value: UserAdminTabType;
}
export enum UserAdminTabType {
  EDIT_USERS = 'EDIT_USERS',
  CUSTOMIZE_ROLES = 'CUSTOMIZE_ROLES',
  CHANGE_PERMISSIONS = 'CHANGE_PERMISSIONS',
  IMPORT_DEFAULT_USERS = 'IMPORT_DEFAULT_USERS',
}

export interface Discipline {
  id: string;
  name: string;
}
